import { menus } from '../const/menus'

const falttenedMenuList = () => {
  const result = []

  const flattenMenusObjects = (menusArray) => {
    let maxLevel = 0

    const getallMenusInArray = (menusArray) => {
      return menusArray.map((item) => {
        const { level, name, linkTo, text, image, subMenus } = item

        if (level > maxLevel) maxLevel = level

        if (!subMenus || !subMenus?.length)
          return { level, name, linkTo, text, image }

        return getallMenusInArray(subMenus)
      })
    }

    const res = getallMenusInArray(menusArray)
    return res.flat(maxLevel)
  }

  menus.forEach((group) => result.push(...flattenMenusObjects(group.menus)))

  return result
}

export default falttenedMenuList
